import type {
  GetBinaryFileContentArgs,
  GetVerificationAttachmentSignedUrlParams,
  GetSignedUrlForApprovedResultParams,
  GetTextFileContentArgs
} from 'services/results/types'

export const QueryKeys = {
  GetTextFileContent: (args: GetTextFileContentArgs) => [
    'text-file-content',
    ...(args
      ? [
          args.runId,
          args.bucket,
          args.containerName,
          args.provider,
          args.storageAccountName,
          args.fileKey,
          args.fetchSignedUrlOnly
        ]
      : [])
  ],
  GetBinaryFileContent: (args?: GetBinaryFileContentArgs) => [
    'binary-file-content',
    ...(args
      ? [
          args.runId,
          args.bucket,
          args.containerName,
          args.provider,
          args.storageAccountName,
          args.fileKey,
          args.fetchSignedUrlOnly
        ]
      : [])
  ],
  GetSignedUrlForApprovedResult: (params: Partial<GetSignedUrlForApprovedResultParams>) => [
    'get-signed-url-for-approved-result',
    params
  ],
  GetVerificationAttachmentSignedUrl: (params: GetVerificationAttachmentSignedUrlParams) => [
    'get-verification-attachment-signed-url',
    params.resultId,
    params.fieldId,
    params.attachmentIndex
  ],
  GetFileContentsFromSignedUrl: (url?: string) => (url ? ['file-view', url] : ['file-view']),
  GetBinaryFileContentFromSignedUrl: (url?: string) =>
    url ? ['binary-file-view', url] : ['binary-file-view'],
  GetValidateMagicLink: (token: string) => ['validate-magic-link', token]
} as const
